import React from "react";
import { Col, Row } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import { CircularProgress } from "@mui/material";
import s from "./styles.scss";

interface Props {
  title?: string;
  message?: string;
  className?: string;
}

const LoadingSpinner: React.FC<Props> = ({
  title = "Loading...",
  message = "Please wait while we process your request.",
  className = "",
}) => {
  return (
    <Row className={`h-100 justify-content-center align-items-center ${className}`}>
      <Col md="6" className="text-center">
        <div className={s.spinnerWrapper}>
          <CircularProgress
            size={50}
            thickness={5}
            className={s.loadingSpinner}
          />
        </div>
        <h5 className={s.title}>{title}</h5>
        <p className={s.message}>{message}</p>
      </Col>
    </Row>
  );
};


export default withStyles(s)(LoadingSpinner);